import type { CogniteClient } from '@cognite/sdk';
import { createContext } from 'react';

/** Context for Cognite SDK client. Use `useCogniteClient` hook instead of consuming directly. */
export const CogniteClientContext = createContext<CogniteClient | null>(null);
